/* Elevaine: swap blog images to AI-generated product-accurate versions */
(function(){
  var map = {
    'serum-anti-age-apres-50-ans-guide-complet': 'blog1-serum-anti-age-ai.png',
    'menopause-et-peau-changements-solutions': 'blog2-menopause-peau-ai.png',
    'bakuchiol-vs-retinol-alternative-naturelle': 'blog3-bakuchiol-retinol-ai.png',
    'routine-beaute-minimaliste-50-ans': 'blog4-routine-minimaliste-ai.png',
    'histoire-elevaine-fondateur-martinien': 'blog5-histoire-elevaine-ai.png'
  };
  /* CDN base for theme assets — no query params */
  var cdn = 'https://elevaine.co/cdn/shop/t/47/assets/';

  function swap(){
    var path = window.location.pathname;

    /* Single article page: replace ALL blog images (hero + inline body) */
    if(path.indexOf('/blogs/notizie/')>-1){
      var handle = path.split('/blogs/notizie/')[1];
      if(handle) handle = handle.replace(/\/$/,'').split('?')[0];
      if(map[handle]){
        var newSrc = cdn + map[handle];
        /* Hero image */
        var hero = document.querySelector('.article__featured-image img, .image-wrap.article__featured-image img');
        if(hero){ hero.src = newSrc; hero.srcset = ''; }
        /* Inline body images matching old blog image filenames */
        document.querySelectorAll('.article__body img, .rte img').forEach(function(img){
          var src = img.src || '';
          if(src.indexOf('blog') > -1 && src.indexOf('serum-anti-age') > -1 ||
             src.indexOf('blog') > -1 && src.indexOf('menopause') > -1 ||
             src.indexOf('blog') > -1 && src.indexOf('bakuchiol') > -1 ||
             src.indexOf('blog') > -1 && src.indexOf('routine') > -1 ||
             src.indexOf('blog') > -1 && src.indexOf('histoire') > -1){
            img.src = newSrc;
            img.srcset = '';
          }
        });
      }
    }

    /* Blog listing: replace thumbnails */
    if(path==='/blogs/notizie' || path==='/blogs/notizie/'){
      document.querySelectorAll('.article, article').forEach(function(article){
        var a = article.querySelector('a[href*="/blogs/notizie/"]');
        if(!a) return;
        var href = a.getAttribute('href');
        for(var h in map){
          if(href.indexOf(h)>-1){
            var img = article.querySelector('.article__image img, .article__image-wrap img');
            if(img){ img.src = cdn + map[h]; img.srcset = ''; }
            break;
          }
        }
      });
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', swap);
  else swap();
  /* Also run after a short delay in case images load async */
  setTimeout(swap, 1500);
})();
